<template><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 4 4"><circle cx="2" cy="2" r="2"/></svg></template>